const cross_join_with = (current: any[][], next: any[]) =>
	next.map((n) => current.map((c) => c.concat(n))).reduce((a, b) => a.concat(b), []);

export const cross_join = (sets: any[][]) => {
	let seed = sets.shift().map((x) => [x]);
	return sets.reduce(cross_join_with, seed);
};
